import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { CommonComponent } from "../../common/common-component";
import { ConfigService } from "../../common/service/config.service";
import { ActivatedRoute, Router, RouterLink } from "@angular/router";
import { ContentBlockComponent } from "../../component/content-block/content-block.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { JsonPipe, NgForOf, NgIf } from "@angular/common";

@Component({
  selector: 'section#choose',
  standalone: true,
  imports: [
    ContentBlockComponent,
    FormsModule,
    NgIf,
    ReactiveFormsModule,
    RouterLink,
    JsonPipe,
    NgForOf
  ],
  templateUrl: './choose.component.html'
})
export class ChooseComponent extends CommonComponent implements OnInit {

  @ViewChild('modal') modal!: ElementRef;

  public boothMode: boolean = false;
  public blocks: any;

  constructor(
    private configService: ConfigService,
    private router: Router,
    private route: ActivatedRoute,
    @Inject('Storage') protected storage: Storage
  ) {
    super();
    this.boothMode = this.storage.getItem('forceBoothMode') === 'true';
  }

  ngOnInit(): void {
    this.configService.config$.subscribe((config) => {
      this.config = config;
      this.blocks = this.getBlocks();
    });
  }

  getBlocks() {
    const blocks = [];
    if(this.config) {
      for (const [slug, value] of Object.entries(this.config.contentBlocks)) {
        if (slug.startsWith('choose-block-')) {
          let index = slug.split('-')[2];
          let block = this.config.contentBlocks[slug];
          if(block.type === 'image') {
            blocks.push({ slug: slug, block: JSON.parse(block.content), index: index });
          }
          else {
            blocks.push({ slug: slug, block: block.content, index: index });
          }
        }
      }

      blocks.sort((a, b) => {
        return parseInt(a.index, 10) - parseInt(b.index,10);
      });
    }

    return blocks;
  }

  select(key: any, value: any) {
    console.log(key, value);
    const payload: any = JSON.parse(this.storage.getItem('user_config') || '{}');
    payload[key] = value;
    this.storage.setItem('user_config', JSON.stringify(payload));
    this.router.navigate([ '..', 'capture' ], { relativeTo: this.route }).then();
  }
}
